import * as React from 'react';
import TwoColRow from './TwoColRow';
const VehicleOwnershipSummary = ({ value, i18n, formatDate }) => (React.createElement(React.Fragment, null,
    React.createElement(TwoColRow, { label: i18n('readreport.content.vehicles.overview.amount.caption'), value: value.vehicles.length }),
    React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('stateauthority.transport')} (${formatDate(value.verificationDate)})` })));
export default VehicleOwnershipSummary;
